import { render, staticRenderFns } from "./ModalLimpar.vue?vue&type=template&id=4f754610&"
import script from "./ModalLimpar.vue?vue&type=script&lang=js&"
export * from "./ModalLimpar.vue?vue&type=script&lang=js&"
import style0 from "./ModalLimpar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports